module.exports = __webpack_public_path__ + "img/card-contract-document-configuration-hover.a0f7bf83.svg";